import axios from "axios";
import {
  addEnvoieFailure,
  addEnvoieStart,
  addEnvoieSuccess,
  getEnvoieFailure,
  getEnvoieStart,
  getEnvoieSuccess,
  getEnvoisFailure,
  getEnvoisStart,
  getEnvoisSuccess,
  getHistoriesEnvoieFailure,
  getHistoriesEnvoieStart,
  getHistoriesEnvoieSuccess,
  simulateCostFailure,
  simulateCostStart,
  simulateCostSuccess,
  updateEnvoieFailure,
  updateEnvoieStart,
  updateEnvoieSuccess,
} from "./EnvoieActions";
import { API_URL } from "../../config/runtimeConfig";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const getEnvois = async (
  dispatch,
  pageSize,
  page,
  id,
  clientOrEntreprise,
  typeEnvoie,
  typeRamassage,
  typeDelivery,
  statusEnvoie,
  agenceCurrent,
  wilayaDepart,
  currentStatusEnvoie,
  nameArrived,
  telArrived,
  numberArrived,
  dateEnvoie,
) => {
  let envoieFilter = {
    clientOrEntreprise,
    id,
    typeEnvoie,
    typeRamassage,
    typeDelivery,
    statusEnvoie,
    agenceCurrent,
    wilayaDepart,
    currentStatusEnvoie,
    nameArrived,
    telArrived,
    numberArrived,
    dateEnvoie,
  };
  dispatch(getEnvoisStart());
  try {
    const res = await axiosInstance.post(
      `/client/envois?pageSize=${pageSize}&page=${page}`,
      envoieFilter,
      {
        headers: {
          token:
            `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
        },
      },
    );
    dispatch(getEnvoisSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getEnvoisFailure(err.response.data.message));
    } else {
      dispatch(getEnvoisFailure("Unkown Error"));
    }
  }
};

export const addEnvoie = async (
  dispatch,
  idTypeEnvoie,
  idTypeDelivery,
  idTypeRamassage,
  idWilayaSender,
  idAgenceSender,
  addressSender,
  nomSender,
  emailSender,
  tel1Sender,
  tel2Sender,
  nom,
  prenom,
  email,
  tel1,
  tel2,
  idWilaya,
  idCommune,
  address,
  idAgenceReceiver,
  description,
  number,
  montant,
  idNature,
  weight,
) => {
  dispatch(addEnvoieStart());

  let envoie = {
    typeEnvoie: idTypeEnvoie,
    typeDelivery: idTypeDelivery,
    typeRamassage: idTypeRamassage,
    wilayaDeparture: idWilayaSender,
    agenceDeparture: idAgenceSender,
    addressDeparture: addressSender,
    nomDeparture: nomSender,
    emailDeparture: emailSender,
    tel1Departure: tel1Sender,
    tel2Departure: tel2Sender,
    nom,
    prenom,
    email,
    tel1,
    tel2,
    wilaya: idWilaya,
    commune: idCommune,
    address,
    agenceArrived: idAgenceReceiver,
    description,
    number,
    montant,
    nature: idNature,
    weight,
  };

  try {
    const res = await axiosInstance.post(`/client/envois/add`, envoie, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(addEnvoieSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(addEnvoieFailure(err.response.data.message));
    } else {
      dispatch(addEnvoieFailure("Unkown Error"));
    }
  }
};

export const updateEnvoie = async (
  dispatch,
  id,
  idTypeEnvoie,
  idTypeDelivery,
  idTypeRamassage,
  idWilayaSender,
  idAgenceSender,
  addressSender,
  nomSender,
  emailSender,
  tel1Sender,
  tel2Sender,
  nom,
  prenom,
  email,
  tel1,
  tel2,
  idWilaya,
  idCommune,
  address,
  idAgenceReceiver,
  description,
  number,
  montant,
  idNature,
  weight,
) => {
  let envoie = {
    id,
    typeEnvoie: idTypeEnvoie,
    typeDelivery: idTypeDelivery,
    typeRamassage: idTypeRamassage,
    wilayaDeparture: idWilayaSender,
    agenceDeparture: idAgenceSender,
    addressDeparture: addressSender,
    nomDeparture: nomSender,
    emailDeparture: emailSender,
    tel1Departure: tel1Sender,
    tel2Departure: tel2Sender,
    nom,
    prenom,
    email,
    tel1,
    tel2,
    wilaya: idWilaya,
    commune: idCommune,
    address,
    agenceArrived: idAgenceReceiver,
    description,
    number,
    montant,
    nature: idNature,
    weight,
  };
  dispatch(updateEnvoieStart());
  try {
    const res = await axiosInstance.post(`/client/envois/update`, envoie, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(updateEnvoieSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(updateEnvoieFailure(err.response.data.message));
    } else {
      dispatch(updateEnvoieFailure("Unkown Error"));
    }
  }
};

export const getOneEnvoie = async (dispatch, id) => {
  dispatch(getEnvoieStart());
  try {
    const res = await axiosInstance.get(`/client/envois/${id}`, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(getEnvoieSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getEnvoieFailure(err.response.data.message));
    } else {
      dispatch(getEnvoieFailure("Unkown Error"));
    }
  }
};
export const simulateGetCost = async (
  dispatch,
  wilayaDepart,
  wilayaArrivee,
  weight,
  typeEnvoie,
  typeDelivery,
  typeRamassage,
  EntrepriseId,
) => {
  dispatch(simulateCostStart());
  let constBody = {
    wilayaDepart,
    wilayaArrivee,
    weight,
    typeEnvoie,
    typeDelivery,
    typeRamassage,
    EntrepriseId,
  };
  try {
    const res = await axiosInstance.post(
      `/client/envois/cost/simulate`,
      constBody,
      {
        headers: {
          token:
            `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
        },
      },
    );
    dispatch(simulateCostSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(simulateCostFailure(err.response.data.message));
    } else {
      dispatch(simulateCostFailure("Unkown Error"));
    }
  }
};

export const getHistories = async (dispatch, EnvoiId) => {
  let envoieFilter = { EnvoiId };
  dispatch(getHistoriesEnvoieStart());
  try {
    const res = await axiosInstance.post(
      `/client/envois/tracking`,
      envoieFilter,
      {
        headers: {
          token:
            `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
        },
      },
    );
    dispatch(getHistoriesEnvoieSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getHistoriesEnvoieFailure(err.response.data.message));
    } else {
      dispatch(getHistoriesEnvoieFailure("Unkown Error"));
    }
  }
};
